<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{ folder }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-header collapse="condense">
    <ion-toolbar>
      <ion-title size="large">{{ folder }}</ion-title>
    </ion-toolbar>
  </ion-header>

  <div id="container">
<!--    <div *ngIf="user$ | async as user" class="profile-container">-->
<!--        <img [src]="user.picture" [alt]="user.name" />-->
<!--      <h2>{{ user.name }}</h2>-->
<!--      <p>{{ user.email }}</p>-->
<!--    </div>-->

    <strong class="capitalize">{{ folder }}</strong>
<!--    <p-button (click)="download()" label="Download BD json"></p-button>-->
    <p-button (click)="ExportDb()" label="ExportDb BD BINÁRIO"></p-button>
<!--    <ion-button type="button" (click)="fileInput.click()">Importar JSON-->
<!--      <input #fileInput type="file" accept="*/*" (change)="uploadPF($event)" style="display:none;"/>-->
<!--    </ion-button>-->
    <ion-button type="button" (click)="binaryInput.click()">Importar Binário
      <input #binaryInput type="file" accept="*/*" (change)="uploadBinary($event)" style="display:none;"/>
    </ion-button>
    {{contagem}}
    versao: {{versao | json}}
    <ion-button (click)="login()">Login</ion-button>
    <ion-button (click)="contar()">Contar Biomas</ion-button>
    <ion-button (click)="baixar()">Sincronizar</ion-button>
    <ion-button (click)="gravar()">Gravar</ion-button>
  </div>
</ion-content>

